import { isString } from '@vue/shared'

const baseProps = {
  modelValue: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'text',
  },
  placeholder: {
    type: String,
    default: '',
  },
}
const functionalProps = {
  disabled: {
    type: Boolean,
    default: false,
  },
  allowClear: {
    type: Boolean,
    default: true,
  },
  maxlength: {
    type: Number,
    default: null,
  }
}
// 对于样式类的属性，统一分类在后续进行统一处理
export const styleProps = {
  width: {
    type: Number,
    default: 0,
    dispose: 'wrapper',
  },
  inputWrapperStyle: {
    type: Object,
    default: {},
    dispose: 'wrapper',
  },
  inputInnterStyle: {
    type: Object,
    default: {},
    dispose: 'inner',
  },
  backgroundColor: {
    type: String,
    default: '',
    dispose: 'both',
  },
  border: {
    type: Boolean,
    default: true,
    dispose: 'wrapper',
  },
  height: {
    type: Number,
    default: 0,
    dispose: 'wrapper',
  },  
  placeholderPosition: {
    type: String,
    default: 'left',
    dispose: 'inner',
  },
}

export const inputProps = {
  ...baseProps,
  ...functionalProps,
  ...styleProps
}

export const inputEmit = {
  ["update:modelValue"]: (value: string) => isString(value),
  input: (value: string) => isString(value),
  blur: (e: FocusEvent) => e instanceof FocusEvent,
  clear: () => true,
  change: (value: string) => isString(value),
}